<template>
  <div class="jbgQrcode">
        <el-dialog title="扫码加入鲸报告" :modal-append-to-body="false" :append-to-body="false"  :visible.sync="jbgQrcode" width="300px" :before-close="cleaseJbgQrcode">
            <img style="margin: auto; width: 200px" src="~common/images/index/jbgqrcode.jpg" alt="二维码">
        </el-dialog>
    </div>
</template>

<script>
import $ from 'jquery'
export default {
    name: 'jbg',
    data() {
        return {
            jbgQrcode: false
        }
    },
    methods: {
        qrcode() {  // 开启鲸报告弹窗二维码
           this.jbgQrcode = true
           this.$nextTick(() => {
               $('body').attr('style','')
           })
        },
        cleaseJbgQrcode() { // 关闭鲸报告弹窗二维码
            this.jbgQrcode = false
        }
    },
}
</script>

<style>

</style>